document.querySelectorAll('[data-tabs]').forEach((tabGroup) => {
  const tabs = tabGroup.querySelectorAll(':scope > * > [role="tab"]');
  const tabPanels = tabGroup.querySelectorAll(':scope > * > [role="tabpanel"]');

  // console.log('Tabs initialized');
  // console.log(tabGroup);

  function activateTab(tab, giveFocus = true) {
    // Deselect all tabs in the group
    tabs.forEach((t) => t.setAttribute('aria-selected', false));

    // Hide all tab panels in the group and remove tabindex
    tabPanels.forEach((panel) => {
      panel.hidden = true;
      panel.removeAttribute('tabindex');
    });

    // Select clicked tab
    tab.setAttribute('aria-selected', true);

    // Show associated panel and set tabindex="0"
    const panel = tabGroup.querySelector(
      `#${tab.getAttribute('aria-controls')}`
    );
    if (panel) {
      panel.hidden = false;
      panel.setAttribute('tabindex', '0');
      if (giveFocus) panel.focus({ preventScroll: true });
    }

    // if not already in view, scroll to it
    if (panel && giveFocus) {
      const rect = panel.getBoundingClientRect();
      const inView =
        rect.top >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight);
      if (!inView) {
        const siteHeader = document.querySelector('.site-header');
        const headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
        window.scrollTo({
          top:
            window.scrollY +
            tabGroup.getBoundingClientRect().top -
            headerHeight -
            20,
          behavior: 'smooth',
        });
      }
    }
  }

  // Handle tab clicks
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const panelId = tab.getAttribute('aria-controls');
      activateTab(tab);

      // Update URL hash only if [data-tabs-update-url] is present
      if (tabGroup.hasAttribute('data-tabs-update-url')) {
        history.replaceState(null, '', `#${panelId}`);
      }
    });
  });

  // On page load, check hash and activate corresponding tab
  document.addEventListener('DOMContentLoaded', () => {
    const hash = window.location.hash.slice(1); // remove #
    const tabToActivate = [...tabs].find(
      (tab) => tab.getAttribute('aria-controls') === hash
    );
    if (tabToActivate) {
      activateTab(tabToActivate, false);
    } else {
      // Default to first tab in the group
      activateTab(tabs[0], false);
    }
  });

  // Handle previous and next button clicks
  const prevButton = tabGroup.querySelector('[data-tabs-prev]');
  const nextButton = tabGroup.querySelector('[data-tabs-next]');

  if (prevButton) {
    prevButton.addEventListener('click', () => {
      const currentIndex = [...tabs].findIndex(
        (tab) => tab.getAttribute('aria-selected') === 'true'
      );
      const prevIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      activateTab(tabs[prevIndex]);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      const currentIndex = [...tabs].findIndex(
        (tab) => tab.getAttribute('aria-selected') === 'true'
      );
      const nextIndex = (currentIndex + 1) % tabs.length;
      activateTab(tabs[nextIndex]);
    });
  }
});

document.querySelectorAll('[data-controls-tab]').forEach((control) => {
  control.addEventListener('click', (e) => {
    const tabId = control.getAttribute('data-controls-tab');
    const tab = document.querySelector(
      `[role="tab"][aria-controls="${tabId}"]`
    );
    if (tab) {
      tab.click();
      const panel = document.getElementById(tabId);
      if (panel) {
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    e.preventDefault();
    return false;
  });
});
